import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import featureRules from './featureRules';

/**
 * Use this hook to check if a feature is enabled.
 *
 * @example
 * const isEnabled = useFeature('flag-name');
 */
export default function useFeature(flagName: string, defaultValue?: any) {
  const context = useLDClient()?.getContext();
  const flags = useFlags();
  const ldFlagValue = flags[flagName];

  const flagValue =
    typeof ldFlagValue === 'undefined' ? defaultValue : ldFlagValue;

  const featureRule = featureRules.getRule(flagName);
  if (typeof featureRule === 'function') {
    return featureRule(flagValue, context);
  }

  return flagValue;
}
